/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The data IDs used in the Segmentation screen.
 * @export
 */
export const SEGMENTATION_DATA_IDS = {
  createSegment: `Button: Create segment`,
  deleteSegmentDialog: `Dialog: Delete segment confirmation dialog`,
  deleteSegmentDialogButtonCancel: `Button: Cancel delete segment`,
  deleteSegmentDialogButtonDelete: `Button: Delete segment`,
  deleteSegmentDialogError: `Error message: Delete segment error`,
  removeEventFeedButton: `Button: Remove event feed`,
  saveSuccessMetricsButton: `Button: Save success metrics`,
  saveSuccessMetricsToastFailure: `Toast: Failed saving success metrics`,
  saveSuccessMetricsToastSuccess: `Toast: Saved success metrics successfully`,
  segmentActionMenuAddSuccessButton: `Action menu: segment add success metric button`,
  segmentActionMenuButton: `Action menu: Segment menu button`,
  segmentActionMenuItemDelete: `Action menu item: Delete segment`,
  segmentActionMenuItemViewDetails: `Action menu item: View segment details`,
  segmentGroupSwitcherPriorityList: `Segment Group Switcher: priority list`,
  segmentItem: `Segment list: Segment item`,
  segmentItemDescription: `Segment item: Segment description`,
  segmentItemTitle: `Segment item: Segment title`,
  segmentsListEmptyState: `Segments list: No segments`,
  toastSuccessDeleteSegment: `Toast: Segment deleted`,
};
